/** Shared local readiness. Boundary validation still checks headers, allowed picks and cardinality. */
export function answerReady(selected: readonly string[], other?: string): boolean {
  return selected.length > 0 || (other?.trim().length ?? 0) > 0;
}
